/*
  Add Custom JS to be layered on top of ciritical theme js
*/

console.log('Custom js ###');

//JS override function to update Siblings in session
function fetchAllSiblings(page = 1, siblings = {}) {
    return fetch(`/collections/all?view=siblings&page=${page}`)
        .then(response => response.json())
        .then(products => {
            console.log(`Fetched ${products.length} products from page ${page}`);

            // Stop loop if no products in current page
            if (!products || products.length === 0) {
                console.log(`Stopping at page ${page} — no more products.`);
                return siblings;
            }

            // Collect siblings data
            products.forEach(p => {
                if (!siblings[p.family]) siblings[p.family] = [];
                siblings[p.family].push(p);
            });

            // Continue with next page
            return fetchAllSiblings(page + 1, siblings);
        });
}

// Function wrapper to handle the event and remove listener
function overrideSiblings() {

    const siblingsUpdated = sessionStorage.getItem('siblingsUpdated');

    if (siblingsUpdated) {
        console.log('Siblings already in sessionStorage — skipping override.');
        window.removeEventListener('siblings:allLoaded', overrideSiblings);
        return;
    }
    console.log("Default siblings loaded — fetching complete dataset...");

    fetchAllSiblings().then(allSiblings => {
        allSiblings = _n.filter(allSiblings, set => set.length > 1);
        sessionStorage.setItem(`siblings_${window.siblingStorage}`, JSON.stringify(allSiblings));
        window.siblings = allSiblings;

        console.log("Overridden siblings data with full product list:", window.siblings);
        sessionStorage.setItem("siblingsUpdated", true);

        // Trigger event for other scripts
        _n.trigger(window, 'siblings:loaded', false, true);
        _n.trigger(window, 'siblings:allLoaded', false, true);
    });

    //Detach event listener after first execution
    window.removeEventListener('siblings:allLoaded', overrideSiblings);
    
}

//Register listener and detach after first run
window.addEventListener('siblings:allLoaded', overrideSiblings);

// OVerride function for GeoIP redirection with exceptions
document.addEventListener('DOMContentLoaded', function () {
  if (typeof Geo !== 'undefined') {

    // Backup the original function
    const originalCountryHandler = Geo.handle.country;

    // Override country function
    Geo.handle.country = function() {
      return new Promise((res, rej) => {
        const excludedPaths = ['/collections/aero-active-ii-x-mclaren-f1-team'];
        const currentPath = window.location.pathname;

        if (excludedPaths.includes(currentPath)) {
          console.log('GeoIP redirect skipped for', currentPath);
          res();
          return;
        }

        // If no exclusion, proceed with original behavior
        originalCountryHandler.call(Geo.handle).then(res);
      });
    };

    console.log('Geo.handle.country() successfully overridden with exceptions.');
  }
});

document.addEventListener('collection:allProductsLoaded', function () {
  if (window.Collection) {
    Collection.loader.page = 1;
    Collection.pagination.current_page = 1;
 
    const grid = document.querySelector('[product-grid]');
    if (grid) {
      grid.innerHTML = '';
    }
 
    Collection.loader.renderedPages = [];
 
    Collection.page(1);
  }
});

// THIS BELOW CODE IS USED TO BE FIX THE SEE MORE BUTTON IN COLLECTION TABS
document.querySelectorAll('.tab-link').forEach(tab => {
  tab.addEventListener('click', function() {
    setTimeout(() => {
      let collectionUrl = this.getAttribute('data-collection-url');
      document.getElementById('see-more-link').setAttribute('href', collectionUrl);
    }, 700); // 1000ms = 1 second
  });
});

// Reload Alma Widget Block on Sibling Selection for EU Stores
if (/\.(eu|fr|de|nl)$/i.test(window.location.hostname)) {
  function reInjectAlmaWidgetScript() {
    const oldScript = document.querySelector('script[src*="alma_widget_block.js"]');
    if (oldScript) oldScript.remove();

    const script = document.createElement('script');
    script.src = 'https://cdn.shopify.com/extensions/274dc975-5fcd-4c0a-b62c-078a8f060be7/alma-widget-21/assets/alma_widget_block.js'; // use correct path
    script.async = true;
    document.body.appendChild(script);
  }
  // Observe DOM changes to detect `.product-essentials` re-render
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType === 1 && node.classList.contains('product-essentials')) {
          // Call Alma widget reinjection
          reInjectAlmaWidgetScript();
        }
      }
    }
  });
  // Start observing the main container that holds product sections
  const mainContent = document.querySelector('.product-essentials') || document.body;
  if (mainContent) {
    observer.observe(mainContent, {
      childList: true,
      subtree: true
    });
  }
}